import { createContext, Context } from 'react';
import type { Auth } from './types';

export const AuthContext: Context<Auth | null> = createContext(null);
AuthContext.displayName = 'AuthContext';
